import styled from 'styled-components';
import { BLACK, NEUTRAL_100, PALE_BLUE, WHITE } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const DropdownContainer = (styled.div`
  position: relative;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownHeader = (styled.div<{ $outline?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ $outline = true }) => $outline ? '4px 12px 4px 12px' : '0'};
  background: ${WHITE};
  border-radius: 8px;
  cursor: pointer;
  min-height: 48px; /* Fixed height to maintain consistency */
  border: ${({ $outline = true }) => $outline ? `1px solid ${NEUTRAL_100}` : 'none'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownHeaderContent = (styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 48px; /* Fixed height for content */
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconContainer = (styled.div`
  width: 38px;
  height: 26px;
  min-width: 38px; /* Ensure fixed width */
  min-height: 26px; /* Ensure fixed height */
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  overflow: hidden; /* Prevent overflow from affecting layout */
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconImage = (styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownText = (styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${BLACK};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ChevronIcon = (styled.div<{ $isOpen: boolean }>`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  justify-content: center;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownListContainer = (styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  background: ${PALE_BLUE};
  border: 1px solid ${NEUTRAL_100};
  border-radius: 8px;
  max-height: ${({ $isOpen }) => ($isOpen ? '50vh' : '0')};
  overflow-y: scroll !important; /* Force scrollbar visibility */
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease;
  z-index: 10;

  /* Override global scrollbar hiding for all browsers */
  &::-webkit-scrollbar {
    display: block !important;
    width: 6px !important;
    height: 6px !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent !important;
  }

  &::-webkit-scrollbar-thumb {
    background: ${NEUTRAL_100} !important;
    border-radius: 4px !important;
  }

  /* iOS Safari specific styling */
  @supports (-webkit-touch-callout: none) {
    -webkit-overflow-scrolling: touch !important;
  }

  /* Firefox */
  scrollbar-width: thin !important;

  /* IE and Edge */
  -ms-overflow-style: auto !important;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownList = (styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 300px;
  overflow-y: scroll !important; /* Force scrollbar visibility */

  /* Override global scrollbar hiding for all browsers */
  &::-webkit-scrollbar {
    display: block !important;
    width: 6px !important;
    height: 6px !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent !important;
  }

  &::-webkit-scrollbar-thumb {
    background: ${NEUTRAL_100} !important;
    border-radius: 4px !important;
  }

  /* iOS Safari specific styling */
  @supports (-webkit-touch-callout: none) {
    -webkit-overflow-scrolling: touch !important;
  }

  /* Firefox */
  scrollbar-width: thin !important;

  /* IE and Edge */
  -ms-overflow-style: auto !important;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownItem = (styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  gap: 12px;

  &:hover {
    background-color: ${NEUTRAL_100};
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownItemContent = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 0px 8px;
  gap: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownItemText = (styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${BLACK};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownLabel = (styled.div`
  font-family: ${INTER.medium};
  color: ${BLACK};
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  margin-bottom: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownPlaceholder = (styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${BLACK};
  height: 24px; /* Match the height of DropdownHeaderContent */
  display: flex;
  align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownItemsContainer = (styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DropdownDivider = (styled.div`
  height: 1px;
  background-color: ${NEUTRAL_100};
  width: 100%;
  margin: 0;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
